import Store from '../store/store'
import CartItem from './../classes/CartItem'
import {parseAgreementTags} from "../../../shared/utils/parse-agreement-tags";

export default class SoundKit {
    constructor(kitData) {

        for (var i in kitData) {
            this[i] = kitData[i];
        }

        this.user = Store.state.user;
        this.itemId = this.getRandomId();
        this.duration = this.duration_string;
        if(kitData.samples) {
            this.samples = kitData.samples.map(sample => new SoundKit({
                ...sample,
                isSoundkitSample: true,
                soundkit: this,
                name: sample.original_filename,
                artwork: kitData.artwork,
                duration: sample.duration_string,
                http: sample.stream_url,
            }));
        }
    }

    static makeArray(kitsData) {
        let kits = [];

        for (var i in kitsData) {
            kits.push(new SoundKit(kitsData[i]))
        }

        return kits;
    }

    get tagsFormatted() {
        return this.tags.map((tag) => ({...tag, name: `#${tag.name}`}))
    }

    get hasFilesOrPreviews() {
        return !!this.itemsCount || this.samples?.length
    }

    image(size = 100) {
        if (this.artwork && this.artwork.files) {
            return this.artwork.files[size]
        }
        return this.user.avatar.files[size]
    }

    addToCart(productPricingOption) {
        Store.state.cart.addItem(new CartItem(this, productPricingOption, productPricingOption.price, this.getType()))
    }

    inCart(productPricing = null) {
        return Store.state.cart.inCart(this, productPricing);
    }

    play () {
        if (Store.state.playlistManager.isPlaying(this)) {
            Store.state.playlistManager.resume(this)
        } else {
            Store.state.playlistManager.setPagePlaylistToCurrent()
            Store.state.playlistManager.play(this)
        }
    }

    pause () {
        Store.state.playlistManager.pause()
    }

    getType() {
        return 'soundkit';
    }

    shareUrl() {
        return `${ab.baseUrl}/soundkits/${this.id}`;
    }

    minPrice () {
      if (this.productPricing?.length) {
        const prices = this.productPricing.map(item => item.price)
          .filter(price => !!+price);
        return prices.length ? prices.reduce((previous, current) => Math.min(previous, current)) : 0;
      }
      return 0;
    }

    maxPrice () {
        return this.price;
    }

    playTag () {
        return false;
    }

    isBeat () {
        return false;
    }

    isSong () {
        return false;
    }

    isSoundKit () {
        return true;
    }

    isCollection () {
        return false;
    }

    getRandomId() {
        let number = Math.random();
        number.toString(36);
        return number.toString(36).substr(2, 9);
    }

    hasTerms(pricingOption) {
        return !!pricingOption.agreement
    }

    static parseTerms(pricingOption) {
        return parseAgreementTags(pricingOption?.agreement?.agreement_text)
    }
}
